import React, { useId } from 'react'
import { cn } from '../../lib/cn'

const IconSearch = (props) => (
  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  </svg>
)
const IconSpinner = (props) => (
  <svg viewBox="0 0 24 24" className="animate-spin" {...props}>
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
  </svg>
)
const IconClose = (props) => (
  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
)

/**
 * Campo de búsqueda unificado (icono, estado loading, botón limpiar).
 * @param {{ value:string, onChange:(v:string)=>void, onClear?:()=>void, loading?:boolean,
 *           placeholder?:string, size?:'md'|'lg', label?:string }} props
 */
export const SearchInput = React.forwardRef(function SearchInput(
  { value, onChange, onClear, loading = false, placeholder = 'Buscar…', size = 'md', label, className, ...rest },
  ref
) {
  const id = useId()
  return (
    <div className={cn('relative flex items-center', className)}>
      {label && <label htmlFor={id} className="sr-only">{label}</label>}
      <span className="pointer-events-none absolute left-3.5 text-ink-muted">
        {loading ? <IconSpinner className="h-5 w-5 text-brand-primary" /> : <IconSearch className="h-5 w-5" />}
      </span>
      <input
        ref={ref}
        id={id}
        type="text"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        className={cn(
          'w-full rounded-xl border border-hairline bg-surface pl-11 pr-10 text-ink placeholder:text-ink-muted shadow-sm transition-all focus:outline-none focus:ring-2 focus:ring-brand-primary/40 focus:border-brand-primary',
          size === 'lg' ? 'py-3.5 text-base' : 'py-2.5 text-sm'
        )}
        {...rest}
      />
      {value && (
        <button
          type="button"
          onClick={() => {
            onChange?.('')
            onClear?.()
          }}
          aria-label="Limpiar búsqueda"
          className="absolute right-2.5 rounded-full p-1 text-ink-muted hover:bg-slate-100 hover:text-ink transition-colors"
        >
          <IconClose className="h-4 w-4" />
        </button>
      )}
    </div>
  )
})

export default SearchInput
